import SiteLayout from "@/components/SiteLayout";
import PageMeta from "@/components/PageMeta";
import { assetUrl } from "@/lib/assets";

export default function About() {
  return (
    <SiteLayout>
      <PageMeta
        title="About | Carlton Elleker Chase"
        description="A broad commercial law practice serving individuals and businesses — designed to meet the demand for a flexible, solutions-driven approach to transactions and disputes."
      />
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 pt-10 md:pt-20" data-testid="about-page">
        <h1 className="h-display text-[clamp(2.4rem,7vw,6rem)] max-w-[18ch]">
          THE PROBLEM<br />SOLVING <span className="text-[#1E3668]">LAWYERS</span>
        </h1>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-7 space-y-7 text-graphite/85 leading-relaxed text-lg">
            <p>
              <strong className="font-semibold">Carlton Elleker Chase</strong> is a broad commercial
              law practice serving individuals and businesses, designed to meet the rapidly growing
              demand for a flexible, solutions-driven approach to commercial transactions and disputes.
            </p>
            <p>
              The Carlton Elleker Chase team has grown rapidly to a team of legal professionals,
              including some of the leading financial services, commercial, IP and litigation lawyers
              in the UK. We are highly experienced in running a wide range of UK and international
              deals and claims. Our lawyers are highly specialised and experienced. We leverage
              technology to provide a seamless and cost-effective legal solution.
            </p>
            <p>
              Carlton Elleker Chase was established to provide an alternative to traditional law
              firms, offering lawyers with greater autonomy, less politics and a more flexible
              way of thinking.
            </p>
          </div>
          <figure className="md:col-span-5 hairline overflow-hidden md:sticky md:top-32">
            <img
              src={assetUrl("/brand/about-collaboration.jpg")}
              alt="The Carlton Elleker Chase team in collaboration"
              className="w-full aspect-[4/5] object-cover object-left"
              loading="lazy"
            />
          </figure>
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 pb-24 md:pb-32">
        <blockquote className="hairline-top pt-12 md:pt-16 max-w-4xl">
          <p className="font-light text-[clamp(1.4rem,2.6vw,2.1rem)] leading-snug text-graphite/85 tracking-tight">
            <span className="text-[#1E3668]">“</span>Carlton Elleker Chase was founded on strong collaboration,
            which remains at the heart of what we do and who we are. Our mission is to help clients
            build and grow strong businesses by providing considered, commercial and creative advice
            and strategies which enable our clients to effectively navigate any commercial issues.<span className="text-[#1E3668]">”</span>
          </p>
        </blockquote>
      </section>
    </SiteLayout>
  );
}
